import { Autocomplete, Checkbox, TextField } from "@mui/material";

import React from "react";

const TagAutocomplete = ({
  options,
  label,
  value,
  name,
  icon,
  checkedIcon,
  required,
  onChangeHandler,
}) => {
  return (
    <Autocomplete
      multiple
      fullWidth
      size="small"
      id="checkboxes-tags-demo"
      options={options}
      filterSelectedOptions
      getOptionLabel={(option) => option.name}
      value={value}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(event, newValue) => {
        onChangeHandler({
          target: {
            name: name,
            value: newValue,
          },
        });
      }}
      // ✅ Sprečava submit forme kada se pritisne Enter
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
      filterOptions={(options, state) => {
        const input = state.inputValue.trim().toLowerCase();
        if (input === "") return options;
        return options.filter((option) =>
          option.name.toLowerCase().includes(input)
        );
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
};

export default TagAutocomplete;
